(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-cart-dialog]');
          this.sectionId = this.closest('.shopify-section')?.id?.replace('shopify-section-', '') || 'cart-drawer';
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          if (!window.avelaCartEvents) {
            window.avelaCartEvents = true;
            document.addEventListener('click', (event) => {
              const drawer = document.querySelector('cart-drawer');
              const open = event.target.closest('[data-open-cart]');
              if (open) {
                const path = window.location.pathname.replace(/\/$/, '');
                if (path.endsWith('/cart')) return;
                event.preventDefault();
                drawer?.open();
              }
              if (event.target.closest('[data-close-cart]')) drawer?.dialog?.close();
              const qty = event.target.closest('[data-qty-change]');
              if (qty) {
                const input = qty.closest('.cart-item__qty')?.querySelector('[data-cart-quantity]');
                if (!input) return;
                const next = Math.max(0, Number(input.value || 0) + Number(qty.dataset.qtyChange));
                const clamped = CartDrawer.clampQuantity(input, next);
                if (clamped === Number(input.value) && next > clamped) return;
                input.value = String(clamped);
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
            document.addEventListener('input', (event) => {
              const input = event.target.closest?.('[data-cart-quantity]');
              if (!input || input.value.trim() === '') return;
              const value = Number(input.value);
              const clamped = CartDrawer.clampQuantity(input, value);
              if (clamped !== value) input.value = String(clamped);
            });
            document.addEventListener('submit', (event) => {
              const form = event.target;
              const drawer = document.querySelector('cart-drawer');
              if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
              const submitter = event.submitter;
              const isAdd =
                !submitter ||
                submitter.getAttribute('name') === 'add' ||
                submitter.hasAttribute('data-add') ||
                submitter.hasAttribute('data-sticky-add');
              if (!isAdd) return;
              event.preventDefault();
              drawer?.addFromForm(form);
            });
          }
          this.addEventListener('change', (event) => {
            const input = event.target.closest('[data-cart-quantity]');
            if (!input) return;
            this.change(input.dataset.lineKey, Number(input.value));
          });
          this.addEventListener('click', (event) => {
            const remove = event.target.closest('[data-cart-remove]');
            if (!remove) return;
            event.preventDefault();
            this.change(remove.dataset.lineKey, 0);
          });
        }

        static clampQuantity(input, value) {
          const error = input.closest('.cart-item')?.querySelector('[data-cart-qty-error]');
          const max = input.dataset.max === undefined ? null : Number(input.dataset.max);
          const over = max !== null && value > max;
          if (error) {
            error.textContent = over ? error.dataset.maxTemplate.replace('__COUNT__', String(max)) : '';
            error.hidden = !over;
          }
          input.setAttribute('aria-invalid', over ? 'true' : 'false');
          return over ? max : value;
        }

        static notifyCart(cart) {
          document.dispatchEvent(new CustomEvent('avela:cart-updated', { detail: cart }));
        }

        async refreshCartState() {
          const response = await fetch(`${this.root()}cart.js`, { headers: { Accept: 'application/json' } });
          if (response.ok) CartDrawer.notifyCart(await response.json());
        }

        open() {
          this.dialog?.showModal();
        }

        root() {
          return window.Shopify?.routes?.root || '/';
        }

        async addFromForm(form) {
          const data = new FormData(form);
          const response = await fetch(`${this.root()}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }],
              sections: this.sectionId,
            }),
          });
          const error = form.querySelector('[data-qty-error]');
          if (!response.ok) {
            const json = await response.json().catch(() => ({}));
            if (error) {
              error.textContent = json.description || error.dataset.addError || '';
              error.hidden = !error.textContent;
            }
            return;
          }
          if (error) error.hidden = true;
          const json = await response.json();
          this.applySection(json.sections?.[this.sectionId]);
          const drawer = document.querySelector('cart-drawer');
          drawer?.open();
          drawer?.refreshCartState();
        }

        async change(key, quantity) {
          const response = await fetch(`${this.root()}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: this.sectionId }),
          });
          if (!response.ok) {
            const json = await response.json().catch(() => ({}));
            const input = this.querySelector(`[data-cart-quantity][data-line-key="${CSS.escape(key)}"]`);
            const error = input?.closest('.cart-item')?.querySelector('[data-cart-qty-error]');
            if (error && json.description) {
              error.textContent = json.description;
              error.hidden = false;
            }
            return;
          }
          const json = await response.json();
          this.applySection(json.sections?.[this.sectionId], json.item_count);
          CartDrawer.notifyCart(json);
        }

        applySection(html, itemCount) {
          if (!html) return;
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
          const wasOpen = this.dialog?.open;
          if (next) this.replaceWith(next);
          const drawer = document.querySelector('cart-drawer');
          if (wasOpen) drawer?.open();
          const count = itemCount ?? Number(drawer?.dataset.itemCount || 0);
          document.querySelectorAll('[data-cart-count]').forEach((node) => {
            node.textContent = count > 0 ? String(count) : '';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Sepet sayfasında + / − ile değişen adeti hemen sepete yazıp toplamı yenile
  document.querySelectorAll('.cart-page__form').forEach((form) => {
    let pending = null;
    form.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      clearTimeout(pending);
      pending = setTimeout(async () => {
        form.classList.add('is-updating');
        try {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: input.dataset.lineKey, quantity: Number(input.value) }),
          });
        } finally {
          window.location.reload();
        }
      }, 400);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (async () => {
    // Shopify'da renk/beden filtresi tanımlı değilse temanın yedek filtresi burada uygulanır
    const fallbackInputs = Array.from(document.querySelectorAll('[data-fallback-filter]'));
    const grid = document.querySelector('[data-collection-grid]');
    if (!fallbackInputs.length || !grid) return;
    const params = new URLSearchParams(window.location.search);
    const wanted = {
      colors: params.getAll('filter.v.option.renk'),
      sizes: params.getAll('filter.v.option.beden'),
    };
    fallbackInputs.forEach((input) => {
      const list = input.name === 'filter.v.option.renk' ? wanted.colors : wanted.sizes;
      input.checked = list.includes(input.value);
    });
    if (!wanted.colors.length && !wanted.sizes.length) return;

    const pages = Number(grid.dataset.pages) || 1;
    if (pages > 1) {
      const current = Number(params.get('page')) || 1;
      const others = [];
      for (let page = 1; page <= pages; page += 1) if (page !== current) others.push(page);
      const docs = await Promise.all(
        others.map(async (page) => {
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(page));
          try {
            const response = await fetch(url.toString(), { credentials: 'same-origin' });
            return new DOMParser().parseFromString(await response.text(), 'text/html');
          } catch (error) {
            return null;
          }
        })
      );
      const items = [];
      docs.forEach((doc, index) => {
        if (!doc) return;
        doc.querySelectorAll('[data-collection-grid] > li').forEach((item) => items.push({ page: others[index], item }));
      });
      items
        .sort((a, b) => a.page - b.page)
        .forEach(({ page, item }) => {
          const node = document.importNode(item, true);
          if (page < current) grid.insertBefore(node, grid.firstChild);
          else grid.appendChild(node);
        });
      document.querySelectorAll('[data-collection-pagination]').forEach((nav) => {
        nav.hidden = true;
      });
    }

    const has = (list, value) => list.includes(`|${value}|`);
    let visible = 0;
    grid.querySelectorAll(':scope > li').forEach((item) => {
      const colors = item.dataset.filterColors || '|';
      const sizes = item.dataset.filterSizes || '|';
      const colorOk = !wanted.colors.length || wanted.colors.some((color) => has(colors, color));
      const sizeOk = !wanted.sizes.length || wanted.sizes.some((size) => has(sizes, size));
      item.hidden = !(colorOk && sizeOk);
      if (!item.hidden) visible += 1;
    });
    const empty = document.querySelector('[data-filter-empty]');
    if (empty) empty.hidden = visible > 0;
    const count = document.querySelector('[data-collection-count]');
    if (count) count.textContent = `${visible} ürün`;
  })();

  // Boş fiyat kutularını adrese ekleme
  document.querySelectorAll('.collection__filters').forEach((form) => {
    form.addEventListener('submit', () => {
      form.querySelectorAll('input[name^="filter.v.price"]').forEach((input) => {
        if (input.value.trim() === '') input.disabled = true;
      });
    });
  });

  document.querySelectorAll('[data-price-range]').forEach((range) => {
    const max = Number(range.dataset.max) || 0;
    const sliders = {
      min: range.querySelector('[data-price-slider="min"]'),
      max: range.querySelector('[data-price-slider="max"]'),
    };
    const inputs = {
      min: range.querySelector('[data-price-input="min"]'),
      max: range.querySelector('[data-price-input="max"]'),
    };
    const fill = range.querySelector('[data-price-fill]');
    if (!sliders.min || !sliders.max || !max) return;

    const paint = () => {
      const low = Number(sliders.min.value);
      const high = Number(sliders.max.value);
      fill?.style.setProperty('--price-left', `${(low / max) * 100}%`);
      fill?.style.setProperty('--price-right', `${100 - (high / max) * 100}%`);
    };

    const fromSlider = (side) => {
      let low = Number(sliders.min.value);
      let high = Number(sliders.max.value);
      if (low > high) {
        if (side === 'min') low = high;
        else high = low;
        sliders.min.value = String(low);
        sliders.max.value = String(high);
      }
      inputs.min.value = low > 0 ? String(low) : '';
      inputs.max.value = high < max ? String(high) : '';
      paint();
    };

    const fromInput = (side) => {
      const input = inputs[side];
      input.value = input.value.replace(/[^0-9]/g, '');
      const value = input.value === '' ? (side === 'min' ? 0 : max) : Math.min(Number(input.value), max);
      sliders[side].value = String(value);
      paint();
    };

    ['min', 'max'].forEach((side) => {
      sliders[side].addEventListener('input', () => fromSlider(side));
      inputs[side].addEventListener('input', () => fromInput(side));
      inputs[side].addEventListener('change', () => {
        const low = Number(inputs.min.value || 0);
        const high = Number(inputs.max.value || max);
        if (inputs.min.value && inputs.max.value && low > high) {
          inputs.min.value = String(high);
          inputs.max.value = String(low);
          sliders.min.value = String(high);
          sliders.max.value = String(low);
          paint();
        }
      });
    });
    paint();
  });

  (() => {
    const root = document.querySelector('[data-collection-grid]');
    const toolbar = document.querySelector('.collection__toolbar');
    if (!toolbar) return;

    const storageKey = 'avela-collection-cols';
    const buttons = toolbar.querySelectorAll('[data-grid-view]');
    const applyCols = (cols) => {
      const next = cols === '1' ? '1' : '2';
      if (root) root.dataset.cols = next;
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.gridView === next ? 'true' : 'false');
      });
      try {
        window.localStorage.setItem(storageKey, next);
      } catch (error) {
        return;
      }
    };

    let stored = '2';
    try {
      stored = window.localStorage.getItem(storageKey) || '2';
    } catch (error) {
      stored = '2';
    }
    applyCols(stored);

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyCols(button.dataset.gridView));
    });

    toolbar.querySelectorAll('[data-collection-sort]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', link.dataset.value);
        window.location.assign(url.toString());
      });
    });

    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('.collection__filters input[type="checkbox"]').forEach((input) => {
      const selected = params.getAll(input.name);
      if (selected.includes(input.value)) input.checked = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites"]) return;
  try {
    
  if (!customElements.get('favorites-page')) {
    customElements.define(
      'favorites-page',
      class FavoritesPage extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-favorites-list]');
          this.empty = this.querySelector('[data-favorites-empty]');
          this.cache = new Map();
          this.onChange = () => this.render();
          document.addEventListener('avela:favorites-changed', this.onChange);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('avela:favorites-changed', this.onChange);
        }

        handles() {
          return window.avelaFavorites ? window.avelaFavorites.list() : [];
        }

        money(cents) {
          const sample = this.dataset.moneySample || '1,234.56 ₺';
          const amount = (Number(cents) / 100).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          return sample.replace(/[\d.,]+/, amount);
        }

        async product(handle) {
          if (this.cache.has(handle)) return this.cache.get(handle);
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
          const product = response.ok ? await response.json() : null;
          this.cache.set(handle, product);
          return product;
        }

        card(product) {
          const item = document.createElement('li');
          item.className = 'favorites__card';

          const media = document.createElement('a');
          media.className = 'favorites__media';
          media.href = product.url;
          if (product.featured_image) {
            const image = document.createElement('img');
            const src = product.featured_image.startsWith('//') ? `https:${product.featured_image}` : product.featured_image;
            image.src = `${src}${src.includes('?') ? '&' : '?'}width=600`;
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 600;
            image.height = 800;
            media.appendChild(image);
          }

          const title = document.createElement('a');
          title.className = 'favorites__title';
          title.href = product.url;
          title.textContent = product.title;

          const price = document.createElement('p');
          price.className = 'favorites__price';
          const current = document.createElement('span');
          current.textContent = this.money(product.price);
          price.appendChild(current);
          if (product.compare_at_price > product.price) {
            const compare = document.createElement('s');
            compare.className = 'favorites__compare';
            compare.textContent = this.money(product.compare_at_price);
            price.appendChild(compare);
          }

          item.append(media, title, price);

          if (!product.available) {
            const status = document.createElement('p');
            status.className = 'favorites__status';
            status.textContent = this.dataset.unavailable;
            item.appendChild(status);
          }

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'favorite-button';
          remove.setAttribute('aria-pressed', 'true');
          remove.setAttribute('aria-label', this.dataset.remove);
          remove.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M10 16.5s-6.25-3.6-6.25-8.03A3.47 3.47 0 0 1 7.22 5c1.18 0 2.2.6 2.78 1.5A3.32 3.32 0 0 1 12.78 5a3.47 3.47 0 0 1 3.47 3.47C16.25 12.9 10 16.5 10 16.5Z"/></svg>';
          remove.addEventListener('click', () => window.avelaFavorites?.remove(product.handle));
          item.appendChild(remove);

          return item;
        }

        async render() {
          const handles = this.handles();
          const products = (await Promise.all(handles.map((handle) => this.product(handle).catch(() => null)))).filter(Boolean);
          this.list.replaceChildren(...products.map((product) => this.card(product)));
          this.list.hidden = products.length === 0;
          this.empty.hidden = products.length > 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-bar')) {
    customElements.define(
      'header-bar',
      class HeaderBar extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.querySelector('[data-open-search]')?.addEventListener('click', () => {
            this.dialog?.showModal();
            this.dialog?.querySelector('input[type="search"]')?.focus();
          });
          this.querySelector('[data-close-search]')?.addEventListener('click', () => this.dialog?.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog?.addEventListener('close', () => {
            this.dialog.classList.remove('is-searching');
            this.dialog.querySelector('[data-predictive-results]')?.replaceChildren();
          });
          this.querySelectorAll('[data-close-details]').forEach((button) => {
            button.addEventListener('click', () => button.closest('details')?.removeAttribute('open'));
          });
          this.closeDesktopMenus = (event) => {
            if (event.target.closest('.header-menu__accordion')) return;
            this.querySelectorAll('.header__desktop .header-menu__accordion[open]').forEach((item) => {
              item.removeAttribute('open');
            });
          };
          document.addEventListener('click', this.closeDesktopMenus);
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.closeDesktopMenus(event);
          });
          this.syncStickyOffset = this.syncStickyOffset.bind(this);
          this.syncStickyOffset();
          window.addEventListener('resize', this.syncStickyOffset, { passive: true });
          window.addEventListener('scroll', this.syncStickyOffset, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.syncStickyOffset);
          window.removeEventListener('scroll', this.syncStickyOffset);
          document.removeEventListener('click', this.closeDesktopMenus);
        }

        syncStickyOffset() {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = null;
            const root = document.documentElement;
            const ticker = document.querySelector('[data-ticker]');
            const headerHeight = this.offsetHeight;
            root.style.setProperty('--header-height', `${headerHeight}px`);

            const headerBox = this.getBoundingClientRect();
            let offset = 0;
            if (headerBox.bottom > 0) {
              offset = headerBox.bottom;
            }

            if (ticker) {
              ticker.style.top = `${headerHeight}px`;
              const tickerBox = ticker.getBoundingClientRect();
              if (tickerBox.bottom > 0 && tickerBox.top <= offset + 1) {
                offset = tickerBox.bottom;
              }
            }

            root.style.setProperty('--sticky-offset', `${Math.max(0, Math.round(offset))}px`);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
          this.select = this.querySelector('[data-variant-select]');
          this.addButton = this.querySelector('[data-add]');
          this.price = this.querySelector('[data-price]');
          this.quantityWrap = this.querySelector('[data-quantity-wrap]');
          this.checkoutWrap = this.querySelector('[data-dynamic-checkout]');
          this.stockLimits = JSON.parse(this.querySelector('[data-variant-stock]')?.textContent || '{}');
          this.cartQuantities = JSON.parse(this.querySelector('[data-cart-quantities]')?.textContent || '{}');
          document.addEventListener('avela:cart-updated', (event) => {
            const quantities = {};
            (event.detail?.items || []).forEach((item) => {
              quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
            });
            this.cartQuantities = quantities;
            if (this.qtyInput && this.qtyInput.value.trim() !== '') this.validateQuantity();
          });
          this.qtyInput = this.querySelector('[data-qty-input]');
          this.qtyError = this.querySelector('[data-qty-error]');
          this.qtyInput?.addEventListener('input', () => {
            if (this.qtyInput.value.trim() === '') this.showQuantityError('');
            else this.validateQuantity();
          });
          this.qtyInput?.addEventListener('change', () => this.validateQuantity());
          this.querySelectorAll('[data-qty-step]').forEach((button) => {
            button.addEventListener('click', () => {
              if (!this.qtyInput) return;
              const remaining = this.remainingLimit();
              const current = Number.parseInt(this.qtyInput.value, 10) || 1;
              let next = Math.max(1, current + Number(button.dataset.qtyStep));
              if (remaining !== null) next = Math.max(1, Math.min(next, remaining));
              this.qtyInput.value = String(next);
              this.validateQuantity();
            });
          });
          this.qtyInput?.form?.addEventListener('submit', (event) => {
            if (this.validateQuantity()) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.qtyInput.focus();
          });
          this.stockRequest = this.querySelector('[data-stock-request]');
          this.stockVariant = this.querySelector('[data-stock-variant]');
          this.stockBody = this.querySelector('[data-stock-body]');
          this.bodyTemplate = this.stockRequest?.dataset.bodyTemplate || '';
          this.querySelectorAll('[data-option-position]').forEach((input) => {
            input.addEventListener('change', () => this.updateVariant());
          });
          if (new URLSearchParams(window.location.search).has('contact_posted') && this.stockRequest) {
            this.stockRequest.hidden = false;
          }
          this.alignToPhoto();
          const stage = this.querySelector('.product-gallery__stage');
          if (stage && 'ResizeObserver' in window) {
            this.photoObserver = new ResizeObserver(() => this.alignToPhoto());
            this.photoObserver.observe(stage);
          }
          this.onResize = () => this.alignToPhoto();
          window.addEventListener('resize', this.onResize);
        }

        alignToPhoto() {
          const info = this.querySelector('.product__info');
          const stage = this.querySelector('.product-gallery__stage');
          if (!info || !stage) return;
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          info.style.minHeight = desktop ? `${Math.round(stage.getBoundingClientRect().height)}px` : '';
        }

        currentLimit() {
          const limit = this.stockLimits[this.select?.value];
          return typeof limit === 'number' ? limit : null;
        }

        inCart() {
          return Number(this.cartQuantities[this.select?.value] || 0);
        }

        remainingLimit() {
          const limit = this.currentLimit();
          return limit === null ? null : Math.max(0, limit - this.inCart());
        }

        showQuantityError(message) {
          if (!this.qtyError) return;
          this.qtyError.textContent = message || '';
          this.qtyError.hidden = !message;
          this.qtyInput?.setAttribute('aria-invalid', message ? 'true' : 'false');
        }

        validateQuantity() {
          if (!this.qtyInput) return true;
          const raw = this.qtyInput.value.trim();
          const qty = Number(raw);
          const limit = this.currentLimit();
          if (raw === '' || !Number.isInteger(qty) || qty < 1) {
            this.showQuantityError(this.qtyError?.dataset.invalidMessage);
            return false;
          }
          if (limit !== null && qty > limit) {
            this.showQuantityError(this.qtyError?.dataset.maxTemplate.replace('__COUNT__', String(limit)));
            return false;
          }
          const inCart = this.inCart();
          const remaining = this.remainingLimit();
          if (remaining !== null && qty > remaining) {
            const message =
              remaining === 0
                ? this.qtyError?.dataset.cartFullTemplate.replace('__COUNT__', String(limit))
                : this.qtyError?.dataset.cartMaxTemplate
                    .replace('__COUNT__', String(remaining))
                    .replace('__IN_CART__', String(inCart));
            this.showQuantityError(message);
            return false;
          }
          this.showQuantityError('');
          return true;
        }

        selectedOptions() {
          return Array.from(this.querySelectorAll('[data-option-position]:checked')).map((input) => input.value);
        }

        updateVariant() {
          const options = this.selectedOptions();
          const variant = this.variants.find((item) =>
            options.every((value, index) => item.options[index] === value)
          );
          if (!variant || !this.select) return;
          this.select.value = String(variant.id);
          const option = this.select.selectedOptions[0];
          if (this.addButton) {
            this.addButton.disabled = !variant.available;
            this.addButton.hidden = !variant.available;
          }
          if (this.quantityWrap) this.quantityWrap.hidden = !variant.available;
          if (this.qtyInput) {
            const limit = this.currentLimit();
            if (limit === null) this.qtyInput.removeAttribute('max');
            else this.qtyInput.max = String(limit);
            if (variant.available) this.validateQuantity();
            else this.showQuantityError('');
          }
          if (this.checkoutWrap) this.checkoutWrap.hidden = !variant.available;
          if (this.stockRequest) this.stockRequest.hidden = variant.available;
          if (this.stockVariant) this.stockVariant.value = variant.title || '';
          if (this.stockBody && this.bodyTemplate) {
            this.stockBody.value = this.bodyTemplate.replaceAll('__VARIANT__', variant.title || '');
          }
          const formatted = option?.dataset.price;
          const compare = option?.dataset.compare;
          if (this.price && formatted) {
            const current = this.price.querySelector('.price__current');
            const compareEl = this.price.querySelector('.price__compare');
            if (current) current.textContent = formatted;
            if (compareEl) {
              compareEl.textContent = compare || '';
              compareEl.hidden = !compare;
            }
            this.price.classList.toggle('price--sale', Boolean(compare));
          }
          const save = this.querySelector('[data-save]');
          if (save) {
            const regular = Number(variant.compare_at_price || 0);
            const percent = regular > variant.price ? Math.floor(((regular - variant.price) * 100) / regular) : 0;
            save.hidden = percent === 0;
            const saveValue = save.querySelector('[data-save-value]');
            if (percent && saveValue) saveValue.textContent = String(percent);
          }
          this.querySelector('product-gallery')?.showVariant?.(variant);
          this.querySelectorAll('[data-selected-value]').forEach((label) => {
            const value = variant.options[Number(label.dataset.selectedValue) - 1];
            if (value) label.textContent = value;
          });
          const stock = this.querySelector('[data-stock]');
          if (stock) {
            const qty = Number(variant.inventory_quantity || 0);
            const low = variant.inventory_management === 'shopify' && variant.available && qty > 0 && qty <= 5;
            stock.hidden = !low;
            stock.textContent = low ? (stock.dataset.stockTemplate || '').replace('__COUNT__', String(qty)) : '';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('[data-search-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-bar"] && !Shopify.designMode) return;
  try {
    
  const ticker = document.querySelector('[data-ticker]');
  const header = document.querySelector('header-bar.header-bar--sticky');
  if (ticker && header) {
    const sync = () => {
      ticker.style.top = `${header.offsetHeight}px`;
    };
    sync();
    window.addEventListener('resize', sync);
  }

  } catch(e) { console.error(e); }
})();
})();
